module.exports = __webpack_public_path__ + "img/DSC_1818.d3fb6f6d.JPG";